import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import Spinner from '@/components/ui/spinner'
import { useCurrentUser } from '@/features/auth/state/auth'
import { useUpdateUserStatus } from '@/features/users/services'
import { User } from '@/types/user'
import { memo, useState } from 'react'

type Props = {
  user: User
}

export default memo(function ActivateUserAler({ user }: Props) {
  const currentUser = useCurrentUser()
  const [isOpen, setIsOpen] = useState(user.status === 'Pendente')
  const mutation = useUpdateUserStatus({ onSuccess: () => setIsOpen(false) })

  if (currentUser?.typeCargo !== 'CEO' || user.status === 'Ativo' || typeof user.id === 'undefined' || isOpen === false)
    return null
  return (
    <Alert className="mt-0 mb-6">
      <AlertTitle className="text-red-600">Atenção!</AlertTitle>
      <AlertDescription className="flex flex-col gap-2">
        <p className="text-red-600">Esse usuáio não está ativo! Clique no botão abaixo para ativá-lo.</p>
        <Button
          className="bg-red-600 text-black"
          onClick={() => mutation.mutate({ user_id: user.id as string })}
          disabled={mutation.isPending}
        >
          Ativar {mutation.isPending && <Spinner />}
        </Button>
      </AlertDescription>
    </Alert>
  )
})
